module.exports = __webpack_public_path__ + "48362cb4dba06bfc0ef8c336bf4f6604.glb";